const configOptions = {
    dev: {
        apiEndpoint: `https://api-dev.zoneit.pollycs.com/dev`
    },
    prod: {
        apiEndpoint: `https://api.zoneit.pollycs.com/prod`
    }
}

export default configOptions[process.env.REACT_APP_STAGE]